<script lang="ts" setup>
import { computed } from 'vue'
import { v4 as uuid } from 'uuid'
import { brand } from '@/config/brands'

const props = defineProps<{
  title: string
  collections: any[]
  allData: any
  ending: boolean
  fetching: boolean
  setInfiniteRef: (el: HTMLElement | null) => void
  handleBookClick: (bookId: string) => void
  noMoreText: string
  loadingText: string
}>()

const itemClass = computed(() => {
  const base = 'mb-12px flex items-center space-x-12px cursor-pointer rr-item'
  return brand === 'storlyn'
    ? `${base} storlyn-collection-item storlyn-card-shadow`
    : `${base} border border-n-border-primary bg-n-bg-card`
})
</script>

<template>
  <div :ref="setInfiniteRef" class="page h-100dvh overflow-scroll">
    <BasicNavbar class="color-n-text-2" />

    <div class="rr-list-wrap px-4">
      <div v-for="(item, index) in collections" :key="index">
        <div :class="itemClass" @click="handleBookClick(item.id)">
          <BizBookCover
            :id="uuid()"
            :src="item.contentCoverUrl || ''"
            :extra="{
              module_name: allData.showName,
              module_id: allData.id,
              module_type: allData.columnType,
              author: item.authorInfo.author,
              ...item,
            }"
            class="w-18 rounded-10px"
          />

          <div class="flex-1 min-w-0">
            <p class="text-15px font-bold line-clamp-1 text-n-text-1">
              {{ item.contentName }}
            </p>
            <p class="text-13px mt-8px text-n-text-2 line-clamp-2">
              {{ item.introduce }}
            </p>
            <BizShowTags v-if="item.tagList && item.tagList.length" :tags="item.tagList" class="mt-10px" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="ending" class="py-15px text-13px text-center text-n-text-3">
      {{ noMoreText }}
    </div>
    <div v-else-if="fetching" class="py-15px flex items-center justify-center text-13px text-n-text-3">
      <div class="animate-spin">
        <i-icon-park-outline-loading />
      </div>
    </div>
  </div>
</template>

<style scoped>
.page {
  background: transparent;
}

.rr-list-wrap {
  margin-top: 18px;
}

.rr-item {
  padding: 10px;
  border-radius: 14px;
}

.storlyn-collection-item {
  background: #FFFFFF;
  border: 0;
  border-radius: 14px;
}
</style>
